import { Button, Card } from "@aman/design-system";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { asApiError, type ApiError } from "../api/client";
import { downloadApiFile } from "../api/download";
import { useApiQuery } from "../api/hooks";
import { ApiErrorAlert, DataTable, LoadingTable, PageHeader, StatusBadge } from "../components/common";
import { listFromPayload, stringValue, type AnyRecord } from "../types";

export function OrdersPage() {
  const { t } = useTranslation(); const query = useApiQuery<unknown>("/orders");
  const [busy, setBusy] = useState(false); const [error, setError] = useState<ApiError>();
  const download = async (row: AnyRecord): Promise<void> => {
    setBusy(true); setError(undefined);
    try { const id = stringValue(row["publicId"]); await downloadApiFile(`/orders/${encodeURIComponent(id)}/invoice`, `${stringValue(row["invoiceNumber"], id)}.pdf`, "application/pdf"); }
    catch (caught) { setError(asApiError(caught)); } finally { setBusy(false); }
  };
  return <div className="page-stack"><PageHeader title={t("pages.orders.title")} subtitle={t("pages.orders.subtitle")} />
    <ApiErrorAlert error={query.error ?? error} onRetry={() => void query.reload()} /><Card bodyClassName="card-body--flush">
      {query.loading ? <LoadingTable columns={8} /> : <DataTable rows={listFromPayload(query.data)} columns={[
        { key: "invoiceNumber", label: t("pages.orders.invoiceNumber") },
        { key: "publicId", label: t("pages.orders.orderId"), render: (row) => <code>{stringValue(row["publicId"])}</code> },
        { key: "customerName", label: t("pages.licenses.customer") },
        { key: "displayAmount", label: t("pages.orders.displayPrice"), render: (row) => `${stringValue(row["displayAmount"])} ${stringValue(row["displayCurrency"])}` },
        { key: "totalAmount", label: t("pages.orders.paidCredits"), render: (row) => `${stringValue(row["totalAmount"])} ${t("pages.vouchers.credits")}` },
        { key: "status", label: t("common.status"), render: (row) => <StatusBadge value={row["status"]} /> },
        { key: "createdAt", label: t("common.date") },
      ]} actions={(row) => <Button type="button" size="small" variant="secondary" busy={busy} onClick={() => void download(row)}>{t("pages.orders.invoice")}</Button>} />}
    </Card></div>;
}
